//@ts-nocheck
export const API_URL_AUTH = `${config.VITE_AUTH_URL}/api/actors/customer/v1/`
export const API_URL_AUTH_STORE_LEGACY = `${config.VITE_AUTH_URL}/api/smart-safe-school-v1/`
export const API_URL_STORE = `${config.VITE_STORE_URL}/api/`
export const API_URL_ACTORS = `${config.VITE_ACTORS_URL}/api/`
export const API_URL_PARENT_INVITE = `${config.VITE_ACTORS_URL}/api/parent/invite/`
export const API_URL_PARENT = `${config.VITE_ACTORS_URL}/api/parent/`
export const API_URL_CUSTOMER = `${config.VITE_ACTORS_URL}/api/customer/`
export const API_URL_CATALOG = `${config.VITE_CATALOG_URL}/api/`
export const API_URL_MEDIA = `${config.VITE_MEDIA_URL}/api/`
export const API_URL_STORAGE = config.VITE_STORAGE_URL as string
export const API_URL_WORKSHOPS = `${config.VITE_WORKSHOPS_URL}/api/`
export const API_SUPPORT_URL = `${config.VITE_SUPPORT_URL}/api/support/`
export const VENDOR_URL = config.VITE_VENDOR_URL as string
export const PUBLIC_URL = `${config.VITE_STATIC_RES_URL}/`
export const MANAGER_URL = config.VITE_MANAGER_URL as string
export const STORE_URL = config.VITE_STORE_SITE_URL as string
export const SCHOOL_URL = config.VITE_SCHOOL_URL as string
const SCHOOL_API_URL = config.VITE_SCHOOL_API_URL || 'https://dev-school-api.kidscrafts.shop'
export const API_URL_SCHOOL = `${SCHOOL_API_URL}/api/school/`
export const API_URL_DISTRICT = `${SCHOOL_API_URL}/api/district/`
export const LMS_URL = config.VITE_LMS_URL as string

export const KEY_STRIPE = config.VITE_PK_STRIPE
